import React from "react";

export default function LogoHeader() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#FBFBFB] shadow-sm border-b border-border/50">
      <div className="flex items-center justify-center h-16 sm:h-20">
        <a href="/">
          <img
            src="https://media.base44.com/images/public/69d14ed5d129627680ef5d0f/f192ef588_cropped-Copy-of-host1help1-email-22.png"
            alt="Host1Help1"
            className="h-14 sm:h-16 w-auto"
          />
        </a>
      </div>
    </header>
  );
}